import script from "./PersonChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonChangeView.vue?vue&type=script&setup=true&lang=js"

import "./PersonChangeView.vue?vue&type=style&index=0&id=559b121e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-559b121e"]])

export default __exports__